export const DatetimePickerDayjsFormats =
{
    parse: {
        dateInput    : 'DD-MM-YYYY',
        monthInput   : 'MMMM',
        timeInput    : 'HH:mm',
        datetimeInput: 'DD-MM-YYYY HH:mm',
    },
    display: {
        dateInput           : 'DD-MM-YYYY',
        monthInput          : 'MMMM',
        timeInput           : 'HH:mm',
        datetimeInput       : 'DD-MM-YYYY HH:mm',
        monthYearLabel      : 'YYYY MMMM',
        dateA11yLabel       : 'LL',
        monthYearA11yLabel  : 'MMMM YYYY',
        popupHeaderDateLabel: 'MMM DD, ddd',
    },
};
